module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAGFBMVEV1qtsAAAB1qtvo8fnw8fHx8fH+//////8GzgdbAAAAAXRSTlPUwVjOqwAAAEJJREFUeF7t1DERACAUw9BawAIWvhWwAvbR0E5wJPvbelVQt7uLQCAQSNlpuy1Nt6Fm9zOBBBtLllx2z98FBAKB+B10NsbuACAm8gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bw.png
// module id = zJuz
// module chunks = 0